import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { ShieldAlert, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const { user, impersonating, stopImpersonating } = useAuth();
  if (!impersonating || !user) return null;
  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[60] bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between text-sm">
      <div className="flex items-center gap-2">
        <ShieldAlert className="w-4 h-4" />
        <span className="font-medium">
          Stai impersonando <b>{user.email}</b> ({user.role}) come SuperAdmin
        </span>
      </div>
      <button
        data-testid="stop-impersonating-btn"
        onClick={stopImpersonating}
        className="inline-flex items-center gap-1.5 px-3 h-7 rounded-sm bg-amber-950 text-amber-50 text-xs font-medium hover:bg-amber-900"
      >
        <LogOut className="w-3.5 h-3.5" /> Esci dall'impersonation
      </button>
    </div>
  );
}
